import React, { useState } from "react";
import "../../assests/css/LimousineBooking.css";


const limousineServices = [

    {
        id: 1,
        name: "Mercedes-Benz S-Class",
        category: "Luxury Sedan",
        capacity: 3,
        luggage: 2,
        image: "/images/limousine/mercedes-s-class.jpg",
        description:
            "Premium executive sedan for VIP transportation and business travel.",
        hourly: 150,
        airport: 180,
        fullDay: 900,
    },

    {
        id: 2,
        name: "BMW 7 Series",
        category: "Luxury Sedan",
        capacity: 3,
        luggage: 2,
        image: "/images/limousine/bmw-7-series.jpg",
        description:
            "Luxury executive sedan offering premium comfort and chauffeur service.",
        hourly: 150,
        airport: 180,
        fullDay: 900,
    },

    {
        id: 3,
        name: "Audi A8",
        category: "Luxury Sedan",
        capacity: 3,
        luggage: 2,
        image: "/images/limousine/audi-a8.jpg",
        description:
            "Elegant luxury sedan suitable for corporate and VIP transportation.",
        hourly: 140,
        airport: 170,
        fullDay: 850,
    },

    {
        id: 4,
        name: "Mercedes-Benz E-Class",
        category: "Business Sedan",
        capacity: 3,
        luggage: 2,
        image: "/images/limousine/mercedes-e-class.jpg",
        description:
            "Comfortable business-class sedan for professional transportation.",
        hourly: 130,
        airport: 160,
        fullDay: 800,
    },

    {
        id: 5,
        name: "BMW 5 Series",
        category: "Business Sedan",
        capacity: 3,
        luggage: 2,
        image: "/images/limousine/bmw-5-series.jpg",
        description:
            "Premium business sedan ideal for airport and corporate transfers.",
        hourly: 125,
        airport: 155,
        fullDay: 780,
    },

    {
        id: 6,
        name: "Audi A6",
        category: "Business Sedan",
        capacity: 3,
        luggage: 2,
        image: "/images/limousine/audi-a6.jpg",
        description:
            "Executive sedan with comfortable seating and professional service.",
        hourly: 120,
        airport: 150,
        fullDay: 750,
    },

    {
        id: 7,
        name: "Mercedes-Benz GLS",
        category: "Luxury SUV",
        capacity: 6,
        luggage: 4,
        image: "/images/limousine/mercedes-gls.jpg",
        description:
            "Spacious luxury SUV for families, executives and premium groups.",
        hourly: 200,
        airport: 250,
        fullDay: 1200,
    },

    {
        id: 8,
        name: "BMW X7",
        category: "Luxury SUV",
        capacity: 6,
        luggage: 4,
        image: "/images/limousine/bmw-x7.jpg",
        description:
            "Premium SUV combining luxury, space and comfortable transportation.",
        hourly: 210,
        airport: 260,
        fullDay: 1250,
    },

    {
        id: 9,
        name: "Range Rover",
        category: "Luxury SUV",
        capacity: 5,
        luggage: 4,
        image: "/images/limousine/range-rover.jpg",
        description:
            "Luxury SUV designed for VIP travel and executive transportation.",
        hourly: 220,
        airport: 280,
        fullDay: 1300,
    },

    {
        id: 10,
        name: "Cadillac Escalade",
        category: "Premium SUV",
        capacity: 6,
        luggage: 5,
        image: "/images/limousine/cadillac-escalade.jpg",
        description:
            "Large premium SUV providing excellent comfort for VIP groups.",
        hourly: 230,
        airport: 290,
        fullDay: 1350,
    },

    {
        id: 11,
        name: "GMC Yukon",
        category: "Premium SUV",
        capacity: 7,
        luggage: 5,
        image: "/images/limousine/gmc-yukon.jpg",
        description:
            "Spacious premium SUV suitable for family and group transfers.",
        hourly: 220,
        airport: 280,
        fullDay: 1300,
    },

    {
        id: 12,
        name: "Toyota Land Cruiser",
        category: "Premium SUV",
        capacity: 7,
        luggage: 5,
        image: "/images/limousine/land-cruiser.jpg",
        description:
            "Reliable premium SUV for comfortable group transportation.",
        hourly: 200,
        airport: 260,
        fullDay: 1200,
    },

    {
        id: 13,
        name: "Mercedes-Benz V-Class",
        category: "Luxury Van",
        capacity: 7,
        luggage: 6,
        image: "/images/limousine/mercedes-v-class.jpg",
        description:
            "Luxury passenger van perfect for families, executives and events.",
        hourly: 250,
        airport: 300,
        fullDay: 1500,
    },

    {
        id: 14,
        name: "Mercedes-Benz Vito",
        category: "Passenger Van",
        capacity: 8,
        luggage: 6,
        image: "/images/limousine/mercedes-vito.jpg",
        description:
            "Comfortable passenger van for airport transfers and group travel.",
        hourly: 220,
        airport: 280,
        fullDay: 1350,
    },

    {
        id: 15,
        name: "Toyota Hiace",
        category: "Passenger Van",
        capacity: 10,
        luggage: 8,
        image: "/images/limousine/toyota-hiace.jpg",
        description:
            "Practical passenger van for larger groups and corporate transportation.",
        hourly: 180,
        airport: 240,
        fullDay: 1100,
    },

    {
        id: 16,
        name: "Ford Transit",
        category: "Passenger Van",
        capacity: 12,
        luggage: 10,
        image: "/images/limousine/ford-transit.jpg",
        description:
            "Large passenger vehicle ideal for group transportation and events.",
        hourly: 200,
        airport: 260,
        fullDay: 1200,
    },

    {
        id: 17,
        name: "Mercedes Sprinter",
        category: "VIP Van",
        capacity: 14,
        luggage: 12,
        image: "/images/limousine/mercedes-sprinter.jpg",
        description:
            "Premium group transportation with spacious passenger capacity.",
        hourly: 300,
        airport: 350,
        fullDay: 1800,
    },

    {
        id: 18,
        name: "VIP Sprinter",
        category: "VIP Van",
        capacity: 12,
        luggage: 10,
        image: "/images/limousine/vip-sprinter.jpg",
        description:
            "VIP passenger van designed for luxury group transportation.",
        hourly: 320,
        airport: 380,
        fullDay: 1900,
    },

    {
        id: 19,
        name: "Toyota Granvia",
        category: "Luxury Van",
        capacity: 7,
        luggage: 5,
        image: "/images/limousine/toyota-granvia.jpg",
        description:
            "Premium people carrier offering comfortable executive travel.",
        hourly: 230,
        airport: 280,
        fullDay: 1400,
    },

    {
        id: 20,
        name: "Lexus LM",
        category: "VIP Van",
        capacity: 6,
        luggage: 4,
        image: "/images/limousine/lexus-lm.jpg",
        description:
            "Luxury MPV designed for high-end VIP transportation.",
        hourly: 350,
        airport: 400,
        fullDay: 2200,
    },

    {
        id: 21,
        name: "Genesis G90",
        category: "Luxury Sedan",
        capacity: 3,
        luggage: 2,
        image: "/images/limousine/genesis-g90.jpg",
        description:
            "Premium executive sedan offering refined comfort and style.",
        hourly: 145,
        airport: 175,
        fullDay: 880,
    },

    {
        id: 22,
        name: "Lexus ES",
        category: "Business Sedan",
        capacity: 3,
        luggage: 2,
        image: "/images/limousine/lexus-es.jpg",
        description:
            "Comfortable premium sedan for business and airport transfers.",
        hourly: 120,
        airport: 150,
        fullDay: 750,
    },

    {
        id: 23,
        name: "Lexus LX",
        category: "Luxury SUV",
        capacity: 6,
        luggage: 4,
        image: "/images/limousine/lexus-lx.jpg",
        description:
            "Premium luxury SUV suitable for VIP and executive transportation.",
        hourly: 230,
        airport: 290,
        fullDay: 1400,
    },

    {
        id: 24,
        name: "Toyota Alphard",
        category: "VIP Van",
        capacity: 6,
        luggage: 4,
        image: "/images/limousine/toyota-alphard.jpg",
        description:
            "Luxury MPV with spacious seating for premium passenger travel.",
        hourly: 300,
        airport: 350,
        fullDay: 1800,
    },

];


const LimousineBooking = () => {


    // =====================================================
    // STATES
    // =====================================================

    const [search, setSearch] = useState("");
    const [category, setCategory] = useState("");
    const [pax, setPax] = useState("");


    // =====================================================
    // FILTER VEHICLES
    // =====================================================

    const filteredServices = limousineServices.filter((service) => {

        const searchText = search.trim().toLowerCase();


        const searchMatch =
            searchText === "" ||
            service.name.toLowerCase().includes(searchText) ||
            service.category.toLowerCase().includes(searchText);


        const categoryMatch =
            category === "" ||
            service.category.toLowerCase() ===
            category.toLowerCase();


        const paxNumber = Number(pax);


        const paxMatch =
            pax === "" ||
            (
                paxNumber > 0 &&
                service.capacity >= paxNumber
            );


        return (
            searchMatch &&
            categoryMatch &&
            paxMatch
        );

    });


    // =====================================================
    // CLEAR FILTERS
    // =====================================================

    const clearFilters = () => {

        setSearch("");
        setCategory("");
        setPax("");

    };


    // =====================================================
    // WHATSAPP BOOKING
    // =====================================================

    const handleBooking = (service) => {

        const message = `
Hello Prime Luxury,

I would like to book the following vehicle:

*Vehicle:*
${service.name}

*Category:*
${service.category}

*Passenger Capacity:*
${service.capacity} PAX

*Luggage Capacity:*
${service.luggage} Bags

*Hourly Rate:*
AED ${service.hourly}

*Airport Transfer Rate:*
AED ${service.airport}

*Full Day Rate:*
AED ${service.fullDay}

Please provide me with vehicle availability and booking details.

Thank you.
        `;


        const whatsappURL =
            "https://wa.me/971501011783?text=" +
            encodeURIComponent(message.trim());


        window.open(
            whatsappURL,
            "_blank",
            "noopener,noreferrer"
        );

    };


    return (

        <section className="limousine-booking">


            {/* ================= HEADER ================= */}

            <div className="limousine-header">

                <span className="limousine-header-label">
                    PREMIUM CHAUFFEUR SERVICE
                </span>


                <h1>
                    Limousine Booking
                </h1>


                <p>
                    Choose from our premium range of luxury
                    sedans, SUVs and passenger vans for
                    airport transfers, business travel,
                    events and private transportation.
                </p>

            </div>



            {/* ================= SEARCH AREA ================= */}

            <div className="limousine-search">


                {/* SEARCH VEHICLE */}

                <div className="limousine-search-group">

                    <label htmlFor="limousine-search">
                        Search Vehicle
                    </label>


                    <div className="limousine-input-wrapper">

                        <span className="limousine-input-icon">
                            🔍
                        </span>


                        <input
                            id="limousine-search"
                            type="text"
                            placeholder="Search vehicle..."
                            value={search}
                            onChange={(e) =>
                                setSearch(e.target.value)
                            }
                        />

                    </div>

                </div>



                {/* VEHICLE TYPE */}

                <div className="limousine-search-group">

                    <label htmlFor="vehicle-category">
                        Vehicle Type
                    </label>


                    <div className="limousine-input-wrapper">

                        <span className="limousine-input-icon">
                            🚘
                        </span>


                        <select
                            id="vehicle-category"
                            value={category}
                            onChange={(e) =>
                                setCategory(e.target.value)
                            }
                        >

                            <option value="">
                                All Types
                            </option>

                            <option value="Luxury Sedan">
                                Luxury Sedan
                            </option>

                            <option value="Business Sedan">
                                Business Sedan
                            </option>

                            <option value="Luxury SUV">
                                Luxury SUV
                            </option>

                            <option value="Premium SUV">
                                Premium SUV
                            </option>

                            <option value="Luxury Van">
                                Luxury Van
                            </option>

                            <option value="Passenger Van">
                                Passenger Van
                            </option>

                            <option value="VIP Van">
                                VIP Van
                            </option>

                        </select>

                    </div>

                </div>



                {/* PASSENGERS */}

                <div className="limousine-search-group">

                    <label htmlFor="vehicle-pax">
                        Number of Passengers
                    </label>


                    <div className="limousine-input-wrapper">

                        <span className="limousine-input-icon">
                            👥
                        </span>


                        <input
                            id="vehicle-pax"
                            type="number"
                            min="1"
                            max="50"
                            placeholder="Enter PAX"
                            value={pax}
                            onChange={(e) =>
                                setPax(e.target.value)
                            }
                        />

                    </div>

                </div>



                {/* CLEAR FILTER */}

                {(search || category || pax) && (

                    <button
                        type="button"
                        className="limousine-clear-button"
                        onClick={clearFilters}
                    >
                        Clear Filters
                    </button>

                )}


            </div>



            {/* ================= RESULTS HEADER ================= */}

            <div className="limousine-results-header">

                <div>

                    <h2>
                        Available Vehicles
                    </h2>


                    <span>
                        Showing {filteredServices.length} of{" "}
                        {limousineServices.length} vehicles
                    </span>

                </div>


                {pax && Number(pax) > 0 && (

                    <span className="pax-result">
                        Vehicles for {pax} PAX
                    </span>

                )}

            </div>



            {/* ================= VEHICLE GRID ================= */}

            {filteredServices.length > 0 ? (

                <div className="limousine-grid">


                    {filteredServices.map((service) => (

                        <article
                            className="limousine-card"
                            key={service.id}
                        >


                            {/* ================= IMAGE ================= */}

                            <div className="limousine-image">

                                <img
                                    src={service.image}
                                    alt={service.name}
                                    onError={(e) => {

                                        e.currentTarget.style.display =
                                            "none";

                                        e.currentTarget.parentElement.classList.add(
                                            "limousine-image-fallback"
                                        );

                                    }}
                                />


                                <span className="vehicle-category">
                                    {service.category}
                                </span>

                            </div>



                            {/* ================= CONTENT ================= */}

                            <div className="limousine-card-content">


                                <h3>
                                    {service.name}
                                </h3>


                                <p className="vehicle-description">
                                    {service.description}
                                </p>



                                {/* ================= VEHICLE INFO ================= */}

                                <div className="vehicle-info">


                                    <div className="vehicle-info-item">

                                        <span className="info-icon">
                                            👥
                                        </span>


                                        <div>

                                            <small>
                                                Capacity
                                            </small>


                                            <strong>
                                                {service.capacity} PAX
                                            </strong>

                                        </div>

                                    </div>



                                    <div className="vehicle-info-item">

                                        <span className="info-icon">
                                            🧳
                                        </span>


                                        <div>

                                            <small>
                                                Luggage
                                            </small>


                                            <strong>
                                                {service.luggage} Bags
                                            </strong>

                                        </div>

                                    </div>



                                    <div className="vehicle-info-item">

                                        <span className="info-icon">
                                            🚘
                                        </span>


                                        <div>

                                            <small>
                                                Category
                                            </small>


                                            <strong>
                                                {service.category}
                                            </strong>

                                        </div>

                                    </div>


                                </div>



                                {/* ================= PRICES ================= */}

                                <div className="vehicle-prices">


                                    <div className="price-item">

                                        <span>
                                            Hourly
                                        </span>


                                        <strong>
                                            AED {service.hourly}
                                        </strong>

                                    </div>



                                    <div className="price-item">

                                        <span>
                                            Airport
                                        </span>


                                        <strong>
                                            AED {service.airport}
                                        </strong>

                                    </div>



                                    <div className="price-item">

                                        <span>
                                            Full Day
                                        </span>


                                        <strong>
                                            AED {service.fullDay}
                                        </strong>

                                    </div>


                                </div>



                                {/* ================= WHATSAPP BOOK ================= */}

                                <button
                                    type="button"
                                    className="limousine-book-button"
                                    onClick={() =>
                                        handleBooking(service)
                                    }
                                >

                                    <i className="fab fa-whatsapp"></i>

                                    Book Now

                                    <span>
                                        →
                                    </span>

                                </button>


                            </div>


                        </article>

                    ))}


                </div>


            ) : (


                /* ================= NO RESULTS ================= */

                <div className="limousine-no-results">


                    <div className="no-results-icon">
                        🔍
                    </div>


                    <h3>
                        No Vehicles Found
                    </h3>


                    <p>
                        No limousine vehicles match your
                        current search criteria.
                    </p>


                    <button
                        type="button"
                        onClick={clearFilters}
                    >
                        Clear Filters
                    </button>


                </div>

            )}


        </section>

    );

};


export default LimousineBooking;